import { useTranslation } from 'react-i18next';
import { pushEvent } from '@koob/google-tag-manager';
import { GTM_EVENTS } from '@koob/google-tag-manager/src/events';
import { TripTemplateModal } from '@koob/trip-designer';
import { saveTripTemplate } from '../../../../api/trip';
import { useSnack } from '../../../../hooks';

// Saves the trip as a template: the shared modal draws it, this makes the
// call and tells the user and GTM.
export default function TemplateModal({
  open,
  close,
  onTemplateSaved,
  tripId,
}) {
  const { t } = useTranslation('tripDesigner');
  const { t: tMisc } = useTranslation('misc');
  const { notify } = useSnack();

  const onSave = async ({ name, imageUrl }) => {
    await saveTripTemplate({ tripId, body: { name, imageUrl } });

    notify(t('templateModal.saved'));
    onTemplateSaved();
    pushEvent(GTM_EVENTS.TRIP_SAVED_TEMPLATE, {
      trip_id: tripId,
      template_name: name,
    });
  };

  return (
    <TripTemplateModal
      open={open}
      onClose={close}
      onSave={onSave}
      translation={t}
      importImageLabel={tMisc('importImage')}
    />
  );
}
